import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-geo-bird-page',
  template: '',
})
export class GeoBirdPageComponent implements OnInit {
  private router = inject(Router);

  ngOnInit() {
    window.open('https://app.geo-bird.com?code=innovationhub', '_blank');
    this.router.navigate(['/home']);
  }
}
